import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Outlet } from "@tanstack/react-router"

import { AppShell } from "@/components/layout/app-shell"
import { FilingProperties } from "@/features/filings/components/filing-properties"
import { FilingSidebar } from "@/features/filings/components/filing-sidebar"
import { filingQueries } from "@/queries/filings"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/filings/$filingId"
)({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(filingQueries.detail(params.filingId)),
  component: FilingWorkspaceLayout,
})

function FilingWorkspaceLayout() {
  const { filingId } = Route.useParams()
  const { data: filing } = useSuspenseQuery(filingQueries.detail(filingId))

  return (
    <AppShell
      sidebar={<FilingSidebar filing={filing} />}
      aside={<FilingProperties filing={filing} />}
    >
      <Outlet />
    </AppShell>
  )
}
